import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";

// import { flat } from "@utils";
import { protectedRoutes } from "app/routes";

import GullLayout from "app/layouts/GullLayout";
import AccessDenied from "app/views/sessions/AccessDenied";
import DynamicTitle from "app/components/DynamicTitle";
import useSessionSecurity from "app/hooks/useSessionSecurity";

const userHasPermission = (pathname, user, routes) => {
  if (!user) {
    return false;
  }

  const matched = routes.find((r) => r.path === pathname);
  return matched && matched.auth && matched.auth.length ? matched.auth.includes(user.role) : true;
};

export default function AuthGuard() {
  useSessionSecurity();

  const { pathname } = useLocation();
  const [previousRoute, setPreviousRoute] = useState(null);
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  let hasPermission = userHasPermission(pathname, user, protectedRoutes);

  useEffect(() => {
    if (previousRoute !== null) setPreviousRoute(pathname);
  }, [pathname, previousRoute]);

  return (
    <>
      {isAuthenticated && hasPermission ? (
        <GullLayout>
          <DynamicTitle />
          <Outlet />
        </GullLayout>
      ) : (
        <>
          {isAuthenticated && !hasPermission ? (
            <AccessDenied />
          ) : (
            <Navigate to={previousRoute || "/sessions/signin"} replace={true} />
          )}
        </>
      )}
    </>
  );
}
